var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { LegalCaseManageService } from "~/services/domain-service/legal-case-manage.service";
import CaseMarker from '~/components/common/case-marker.vue';
import Apply from "~/components/visit-case/apply.vue";
import { ApplyType, CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import { Getter, Mutation, namespace, State } from "vuex-class";
import { CaseInfoService } from '~/services/domain-service/case-info.service';
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
var CollectionExecutionModule = namespace("collection-execution");
var LegalPersonCaseManage = /** @class */ (function (_super) {
    __extends(LegalPersonCaseManage, _super);
    function LegalPersonCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            currentCollectorRealName: '',
            partnerName: '',
            batchNumber: '',
            caseMark: ''
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.caseMark = "";
        _this.dialog = {
            apply: false
        };
        _this.applyType = ApplyType.turn;
        _this.caseChannel = CASE_CHANNEL.legal;
        _this.totalInfo = {};
        return _this;
    }
    LegalPersonCaseManage.prototype.mounted = function () {
        this.refreshData();
    };
    LegalPersonCaseManage.prototype.activated = function () {
        this.refreshData();
    };
    LegalPersonCaseManage.prototype.departemntChange = function (id, code) { };
    LegalPersonCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        return params;
    };
    /**
     * 查询统计信息
     */
    LegalPersonCaseManage.prototype.queryTotalInfo = function () {
        var _this = this;
        this.legallyCaseManageServiceTestD.personalCasePoolAmount(this.paramsHandler()).subscribe(function (data) { return _this.totalInfo = data; });
    };
    /**
     * 查询翻页信息
     */
    LegalPersonCaseManage.prototype.queryPageInfo = function () {
        var _this = this;
        this.legallyCaseManageServiceTestD
            .personalCasePool(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    LegalPersonCaseManage.prototype.refreshData = function () {
        this.queryTotalInfo();
        this.queryPageInfo();
    };
    /**
     * 表单范围输入框重置
     */
    LegalPersonCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
        this.model.personalCollectionRemainingDays = { min: '', max: "" };
    };
    /**
     * 进入查看执行页
     */
    LegalPersonCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Legal_personal,
            otherData: {
                data: this.model,
                page: this.pageService,
                sort: this.sortService
            }
        });
    };
    /**
     * 申请流转
     */
    LegalPersonCaseManage.prototype.advanceCirculation = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要流转的案件");
            return;
        }
        this.dialog.apply = true;
    };
    Object.defineProperty(LegalPersonCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    LegalPersonCaseManage.prototype.onColorChange = function (val) {
        var colorModel = {
            caseIds: this.selectionList.map(function (v) { return v.id; }),
            caseMark: val,
        };
        this.caseInfoService.caseInfoMarkColor(colorModel).subscribe(this.refreshData);
    };
    __decorate([
        Dependencies(PageService)
    ], LegalPersonCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LegalPersonCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], LegalPersonCaseManage.prototype, "legallyCaseManageServiceTestD", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], LegalPersonCaseManage.prototype, "caseInfoService", void 0);
    __decorate([
        Mutation
    ], LegalPersonCaseManage.prototype, "updateCollectionType", void 0);
    __decorate([
        Getter
    ], LegalPersonCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        State
    ], LegalPersonCaseManage.prototype, "principalList", void 0);
    LegalPersonCaseManage = __decorate([
        Auth(302),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                CaseMarker: CaseMarker,
                Apply: Apply,
                GetLabelName: GetLabelName,
                SelectDepartment: SelectDepartment
            }
        })
    ], LegalPersonCaseManage);
    return LegalPersonCaseManage;
}(Vue));
export default LegalPersonCaseManage;
